import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PageWrapper, Loader, Alert, Pagination } from '../../components';
import Actions, { thunks } from '../../redux/modules/agents';

class PurchaseHistory extends React.Component {
   

    componentDidMount() {
        const { dispatch, match: { params: { id }} } = this.props;
        dispatch(thunks.getPurchaseHistory(id));
    }
    

    onNext = () => {
        const { dispatch, match: { params: { id }} } = this.props;
        dispatch(thunks.loadPurchaseHistory(id));
    }

    render() {
        const {
            list,
            loading,
            error,
            updateProperty,
            nextPageToken,
            match: { params: { name }} 
        } = this.props;
       
        return (
            <PageWrapper title="Purchase History">
                <Loader show={loading} />
                <Alert
                    show={!!error}
                    onHide={() => updateProperty('error', '')}
                    title="Purchase History"
                    message={error}
                />
                <div className="animated fadeIn">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="d-flex justify-content-between p-4">
                                    <b>Franchise Owner:{name} </b>
                                    <b>Commission:{list.totalCommission} INR</b>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Products</th>
                                                    <th>Total Amount</th>
                                                    <th>Paid Amount</th>
                                                    <th>Balance Amount</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    list?.commissions?.length ? (
                                                        list.commissions.map((user, index) => (
                                                            <tr key={user.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{user.order.address.nickName}</td>
                                                                <td>
                                                                {user.order.items && user.order.items && user.order.items.map((product)=>(
                                                                    
                                                                    <p>{product.title}</p>
                                                                    
                                                                ))}
                                                                </td>
                                                                {/* <td>{user.order.items}</td> */}
                                                                <td>{user.order.orderTotal}</td>
                                                                <td>{user.order.amountPaid}</td>
                                                                <td>{user.order.orderTotal-user.order.amountPaid}</td>
                                                                <td className="font-weight-bold text-primary">{user.order.actualStatus}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="8" className="text-center">No Records Found</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        nextPageToken={nextPageToken}
                                        onNext={this.onNext}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        )
    }
}

const mapStateToProps = ({
    agents: {
        loading,
        error,
        list,
        nextPageToken,
    },
}) => ({
    loading,
    error,
    list,
    nextPageToken,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    reset: bindActionCreators(Actions, dispatch).reset,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseHistory)